import React from 'react';
import ResetForm from './components/ResetForm';

export default function Reset() {
	return <ResetForm />;
}
